import { motion } from "framer-motion";
import { DeviceMobile } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

const FloatingAppButton = () => {
  return (
    <Link to="/app">
      <motion.div
        initial={{ opacity: 0, scale: 0.8, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ delay: 2, duration: 0.5 }}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        data-testid="floating-app-btn"
        className="fixed bottom-6 left-6 z-50 bg-[#2C2C2C] text-white px-4 py-2.5 sm:px-5 sm:py-3 rounded-full shadow-xl flex items-center gap-2 cursor-pointer hover:bg-[#9A8C73] transition-colors duration-300"
      >
        <DeviceMobile size={20} weight="fill" />
        <span className="text-sm font-semibold uppercase tracking-wider">App</span>
      </motion.div>
    </Link>
  );
};

export default FloatingAppButton;
